import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { LabelNameMap } from '../step-label-maps';

@Component({
   selector: 'app-row-form',
   templateUrl: './row-form.component.html',
   styleUrls: ['./row-form.component.scss'],
})
export class RowFormComponent implements OnInit {
   @Input() ratingForm!: AbstractControl | null;
   @Input() step!: string;
   @Input() labelMap!: LabelNameMap;
   @Input() ratings: (number | string)[] = [1, 2, 3, 4, 5];

   // pomoćni getter da template bude čist
   get fg(): FormGroup | null {
      return this.ratingForm as FormGroup | null;
   }
   constructor() {}

   ngOnInit(): void {}
}
